import createNativeBridge from './index';
import { getSiteUrlForPath, queryString } from 'lib/format';

/**
 * This library uses the native-bridge library to formulate ESPN App specific link language calls
 */

const nativeBridge = createNativeBridge();

const PROTOCOL = 'sportscenter://';
const DIRECTIVE = 'x-callback-url';
const BASE_URL = `${PROTOCOL}${DIRECTIVE}`;

function sendTakeActionMessage(action, urlParams) {
    if (nativeBridge && action && urlParams) {
        nativeBridge.sendMessage('takeAction', {
            url:  escape(getAppLink(action, urlParams))
        });
    }
}

export function getAppLink(action, urlParams = {}, useProtocolOnly = false) {
    let appLink;

    // NOTE: Only redirect with PROTOCOL -- `sportscenter://`
    // SEE: https://espnjira.disney.com/browse/WEWEB-2071
    if (useProtocolOnly) {
        return PROTOCOL;
    }

    if (action && urlParams) {
        const actionPath = `${action}${queryString(urlParams, true)}`;
        appLink =`${BASE_URL}/${actionPath}`;
    }

    return appLink;
}

export function appReady() {
    nativeBridge && nativeBridge.sendMessage('onLoadComplete');
}

export function sendLoadVideosMessage(videos = [], tracking = {}) {
    if (nativeBridge && videos.length > 0) {
        nativeBridge.sendMessage('loadVideos', { videos, tracking });
    }
}

export const showWatchStreamByCmsId = (playID, tracking = {}, imageHref, name, network) => {
    if (playID) {
        sendTakeActionMessage('showWatchStream', { ...tracking, playID, imageHref, name, network });
    }
};

export const showWatchStreamByChannel = (playChannel, tracking = {}, imageHref, name, network) => {
    if (playChannel) {
        sendTakeActionMessage('showWatchStream', { ...tracking, playChannel: playChannel.toLowerCase(), imageHref, name, network });
    }
};

export const navigateToPage = (path, title, tracking = {}) => {
    if (path) {
        // app teams request we pass a full URL
        const url = getSiteUrlForPath(path);
        sendTakeActionMessage('navigateToPage', { ...tracking, title, url });
    }
}



// WEBPACK FOOTER //
// ./app/lib/native-bridge/espnapp.js